// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"16b3a30f","331":"5e9f6d41","399":"5e9f6d41","563":"5e9f6d41","775":"8ff018e5"}[chunkId] + ".chunk.css";
};